module.exports = __webpack_public_path__ + "img/0030.68e1c4ea.jpg";